// extracted by mini-css-extract-plugin
export default {"waitingView":"WaitingView_waitingView__drwu3","logo":"WaitingView_logo__550AW","content":"WaitingView_content__NHPwC","player":"WaitingView_player__hQXlj"};